import {
  AG_CHARTS_LOCALE_EN_US,
  AG_CHARTS_LOCALE_ES_ES,
  AG_CHARTS_LOCALE_FR_FR,
} from 'ag-charts-locale';
import antdEnGB from 'antd/locale/en_GB';
import antdEnUS from 'antd/locale/en_US';
import antdEsES from 'antd/locale/es_ES';
import antdFrFR from 'antd/locale/fr_FR';
import dayjs from 'dayjs';

import { Locale } from './types';

export function changeLocale(name: string) {
  dayjs.locale(name);
}

export function getLocale() {
  // Using `as` because no easy cast possible and the locale is anyway linked
  // to the ILanguage in ./types.ts
  return dayjs.locale() as Locale;
}

export function getAntLocaleConfig(language: string) {
  if (language === 'fr') {
    return antdFrFR;
  }
  if (language === 'en-US') {
    return antdEnUS;
  }
  if (language === 'es') {
    return antdEsES;
  }
  return antdEnGB;
}

export function getAgChartLocale(language: string) {
  switch (language) {
    case 'fr':
      return AG_CHARTS_LOCALE_FR_FR;

    case 'es':
      return AG_CHARTS_LOCALE_ES_ES;

    case 'en-US':
    default:
      return AG_CHARTS_LOCALE_EN_US;
  }
}
